import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum TypeEnum {
  全部 = 0,
  高等级 = 1,
  低等级 = 2,
}

// [推荐分监控榜单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=161240282
export const homepage = createAsyncThunk(
  'Saada/live/hiya_socialize/rec_score_rank',
  async (arg: {area_code: hAreaCodeEnum; type: TypeEnum}, store: any) => {
    const resp = await http.post('/live/hiya_socialize/rec_score_rank', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// [推荐分详情] http://wiki.xunlei.cn/pages/viewpage.action?pageId=161240289
export const detail = createAsyncThunk(
  'Saada/live/hiya_socialize/rec_score_detail',
  async (arg: {mid: number; type: 0 | 1}, store: any) => {
    const resp = await http.post('/live/hiya_socialize/rec_score_detail', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  rank?: {
    mid: number
    avatar: string
    level_str: string
    rec_score: number
    rec_score_rank: number
    chat_score: number
    chat_score_rank: number
    pearl: number
  }[]
  detail?: {
    mid: number // 用户 ID
    time: string // 时间字符串
    rec_score: string // 推荐分数（字符串类型）
    rec_score_rank: string // 推荐分数排名（字符串类型）
    level: string // 级别（如 "s"）
    level_score: number // 级别分数
    chat_score: number // 聊天分数
    chat_score_rank: string // 聊天分数排名（字符串类型）
    final_chat_score: number // 最终聊天分数
    ai_score: number // AI 分数
    ai_score_rank: string // AI 分数排名（字符串类型）
    final_ai_score: number // 最终 AI 分数
    total_rank: number // 总排名人数
  }
}

const initialState: InitialStateType = {
  // rank: [
  //   {
  //     mid: 1111,
  //     avatar: 'https://example.com/avatar1.png',
  //     level_str: 'S级',
  //     rec_score: 4.09,
  //     rec_score_rank: 1,
  //     chat_score: 2.88,
  //     chat_score_rank: 1,
  //     pearl: 1000,
  //   },
  //   {
  //     mid: 2222,
  //     avatar: 'https://example.com/avatar2.png',
  //     level_str: 'A级',
  //     rec_score: 3.75,
  //     rec_score_rank: 2,
  //     chat_score: 2.5,
  //     chat_score_rank: 3,
  //     pearl: 850,
  //   },
  //   {
  //     mid: 3333,
  //     avatar: 'https://example.com/avatar3.png',
  //     level_str: 'B级',
  //     rec_score: 4.05,
  //     rec_score_rank: 3,
  //     chat_score: 3.0,
  //     chat_score_rank: 2,
  //     pearl: 950,
  //   },
  //   {
  //     mid: 4444,
  //     avatar: 'https://example.com/avatar4.png',
  //     level_str: 'C级',
  //     rec_score: 3.6,
  //     rec_score_rank: 4,
  //     chat_score: 2.2,
  //     chat_score_rank: 4,
  //     pearl: 700,
  //   },
  //   {
  //     mid: 5555,
  //     avatar: 'https://example.com/avatar5.png',
  //     level_str: 'D级',
  //     rec_score: 2.9,
  //     rec_score_rank: 5,
  //     chat_score: 1.8,
  //     chat_score_rank: 5,
  //     pearl: 500,
  //   },
  // ],
  // detail: {
  //   mid: 1111,
  //   time: '2025.04.30 12:38:00 utc+8',
  //   rec_score: '4.09',
  //   rec_score_rank: '3',
  //   level: 's',
  //   level_score: 1.0,
  //   chat_score: 0.772,
  //   chat_score_rank: '34',
  //   final_chat_score: 0.2,
  //   ai_score: 4.13,
  //   ai_score_rank: '2',
  //   final_ai_score: 0.8,
  //   total_rank: 182, // 总排名人数
  // },
}

export const RecScoreSlice = createSlice({
  name: 'RecScore',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {rank: action.payload?.list || []})
    })
    builder.addCase(detail.fulfilled, (state, action) => {
      Object.assign(state, {
        detail: action.payload?.detail || [],
      })
    })
  },
})
export default RecScoreSlice.reducer
export const RecScoreActions = RecScoreSlice.actions

export const useRecScoreState = () => {
  const data = useSelector((state) => {
    return state.SaadaRecScore
  })
  return data
}
